import { Controller } from "@hotwired/stimulus"
import { rrFetch } from "../utils/rr_fetch"

export default class extends Controller {

    static targets = [
        "filterBttn",
        "intentRow",
    ]

    static values = {
        activeFilters: Array,
    }
    connect() {
        if (!this.hasActiveFiltersValue) {
            this.activeFiltersValue = []
        }
        this.observeLastRow()
    }

    disconnect() {
        this.cleanupObserver()
    }

    observeLastRow() {
        this.cleanupObserver()

        let lastRow = this.intentRowTargets[this.intentRowTargets.length - 1]
        if (!lastRow) return

        this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.loadMore()
                }
            })
        })

        this.observer.observe(lastRow)
    }

    cleanupObserver() {
        if (this.observer) {
            this.observer.disconnect()
            this.observer = null
        }
    }

    toggleFilter(event) {
        const filterType = event.currentTarget.dataset.filter
        const selected = event.currentTarget.dataset.selected === "true"
        if (selected) {
            // Deselect: secondary background, primary text
            event.currentTarget.classList.remove(
                "dark:bg-dark-primary-color", "wdark:bg-wdark-primary-color", "wlight:bg-wlight-primary-color",
                "dark:text-dark-primary-icon-and-text", "wdark:text-wdark-primary-icon-and-text", "wlight:text-wlight-primary-icon-and-text"
            )
            event.currentTarget.classList.add(
                "dark:bg-dark-secondary-color", "wdark:bg-wdark-secondary-color", "wlight:bg-wlight-secondary-color",
                "dark:text-dark-primary-color", "wdark:text-wdark-primary-color", "wlight:text-wlight-primary-color"
            )
            event.currentTarget.dataset.selected = "false"
            this.activeFiltersValue = this.activeFiltersValue.filter(f => f !== filterType)
            this.applyFilters(filterType)

        } else {
            // Select: primary background, primary icon-and-text
            event.currentTarget.classList.remove(
                "dark:bg-dark-secondary-color", "wdark:bg-wdark-secondary-color", "wlight:bg-wlight-secondary-color",
                "dark:text-dark-primary-color", "wdark:text-wdark-primary-color", "wlight:text-wlight-primary-color"
            )
            event.currentTarget.classList.add(
                "dark:bg-dark-primary-color", "wdark:bg-wdark-primary-color", "wlight:bg-wlight-primary-color",
                "dark:text-dark-primary-icon-and-text", "wdark:text-wdark-primary-icon-and-text", "wlight:text-wlight-primary-icon-and-text"
            )
            event.currentTarget.dataset.selected = "true"
            this.activeFiltersValue = [...this.activeFiltersValue, filterType]
            this.applyFilters(filterType)
        }
    }

    async applyFilters() {
        const url = `activity/transactions/filter?type=${this.activeFiltersValue.join(",")}`

        const response = await rrFetch(url, {
            headers: { Accept: "text/vnd.turbo-stream.html" }
        })

        if (response.ok) {
            const stream = await response.text()
            Turbo.renderStreamMessage(stream)

                        requestAnimationFrame(() => {
      this.observeLastRow()
    })
        }
    }

    async loadMore() {
        const lastIntent = this.intentRowTargets[this.intentRowTargets.length - 1]
        const cursor = lastIntent?.dataset.lastModified
        if (!cursor) return

        const url = `activity/transactions/load?type=${this.activeFiltersValue.join(",")}&cursor=${encodeURIComponent(cursor)}&limit=5`

        const response = await rrFetch(url, {
            headers: { Accept: "text/vnd.turbo-stream.html" }
        })

         if (response.status === 204) {
    this.cleanupObserver()
    return
  }

        if (response.ok) {
            const stream = await response.text()
            Turbo.renderStreamMessage(stream)
            this.observeLastRow()
        }
    }

}

